import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import type { ProgressSummary } from '@/types/progress';

export function useProgressSummary() {
  return useQuery({
    queryKey: ['progress-summary'],
    queryFn: async (): Promise<ProgressSummary> =>
      pb.send('/api/progress/summary', { method: 'GET' }),
    staleTime: 30_000,
  });
}
